import React, { useState } from 'react';

import PropTypes from 'prop-types';
import Heading from '@tds/core-heading';
import Box from '@tds/core-box';

import { useLocalizedStringsContext } from '../../../../../../context/LocalizedStringsContext';
import CommentsList from './components/commentsList';
import AddComment from './components/addComment';

const OrderComments = ({ orderData, userRights }) => {
  const {
    ORDERS: { ORDER_COMMENTS }
  } = useLocalizedStringsContext();

  const { canAddComments } = userRights;

  const [newCommentAdded, setNewCommentAdded] = useState(false);
  return (
    <Box between={2}>
      <Heading level="h3">{ORDER_COMMENTS}</Heading>
      <CommentsList orderData={orderData} newCommentAdded={newCommentAdded} />
      {canAddComments && (
        <AddComment
          setNewCommentAdded={setNewCommentAdded}
          orderData={orderData}
        />
      )}
    </Box>
  );
};

OrderComments.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.any).isRequired,
  userRights: PropTypes.objectOf(PropTypes.object).isRequired
};

export default OrderComments;
